import { Navigate } from 'react-router-dom'

const AccountManagementContact = () => {

  return <Navigate to="../details" replace />
}

export default AccountManagementContact
